import React, { useState } from "react";
import {
  GoogleMap,
  Marker,
  // InfoWindow,
  Autocomplete,
  useLoadScript,
} from "@react-google-maps/api";
// import MarkerIcon from "./assets/images/marker.svg";
import { useIntl } from "react-intl";
import Loader from "components/shared/Loader";
// import markerIconPng from "leaflet/dist/images/marker-icon.png";

const Map = ({
  markerPosition,
  setMarkerPosition,
  selectedMarker,
  address,
  setAddress,
}) => {
  const { formatMessage } = useIntl();

  const onLoad = (map) => {
    map.setOptions({
      mapTypeControl: false,
      streetViewControl: false,
      fullscreenControl: false,
      zoomControl: false,
      styles: [
        {
          featureType: "administrative",
          elementType: "labels.text.fill",
          stylers: [
            {
              color: "#444444",
            },
          ],
        },
        {
          featureType: "landscape",
          elementType: "all",
          stylers: [
            {
              color: "#f2f2f2",
            },
          ],
        },
        {
          featureType: "poi",
          elementType: "all",
          stylers: [
            {
              visibility: "off",
            },
          ],
        },
        {
          featureType: "road",
          elementType: "all",
          stylers: [
            {
              saturation: -100,
            },
            {
              lightness: 45,
            },
          ],
        },
        {
          featureType: "road.highway",
          elementType: "all",
          stylers: [
            {
              visibility: "simplified",
            },
          ],
        },
        {
          featureType: "road.arterial",
          elementType: "labels.icon",
          stylers: [
            {
              visibility: "off",
            },
          ],
        },
        {
          featureType: "transit",
          elementType: "all",
          stylers: [
            {
              visibility: "off",
            },
          ],
        },
        {
          featureType: "water",
          elementType: "all",
          stylers: [
            {
              color: "#46bcec",
            },
            {
              visibility: "on",
            },
          ],
        },
      ],
    });
  };

  const customMarkerIcon = {
    url: `data:image/svg+xml;charset=utf-8,${encodeURIComponent(`
       
    <svg width="40" height="40" viewBox="-4 0 36 36" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
        <!-- Uploaded to: SVG Repo, www.svgrepo.com, Generator: SVG Repo Mixer Tools -->
        <title>map-marker</title>
        <desc>Created with Sketch.</desc>
        <defs>
    
    </defs>
        <g id="Vivid.JS" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g id="Vivid-Icons" transform="translate(-125.000000, -643.000000)">
                <g id="Icons" transform="translate(37.000000, 169.000000)">
                    <g id="map-marker" transform="translate(78.000000, 468.000000)">
                        <g transform="translate(10.000000, 6.000000)">
                            <path d="M14,0 C21.732,0 28,5.641 28,12.6 C28,23.963 14,36 14,36 C14,36 0,24.064 0,12.6 C0,5.641 6.268,0 14,0 Z" id="Shape" fill="#0d83c9">
    
    </path>
                            <circle id="Oval" fill="#fff" fill-rule="nonzero" cx="14" cy="14" r="7">
    
    </circle>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
      `)}`,
  };
  const [autocomplete, setAutocomplete] = useState(null);

  const libraries = ["places"];
  const { isLoaded } = useLoadScript({
    googleMapsApiKey: "AIzaSyBAHOh6Fhh7DSaerIWT2ONeCuOLQmKbBMU",
    libraries,
  });

  // handle place select
  const handlePlaceSelect = () => {
    const addressObject = autocomplete.getPlace();
    const address = addressObject.formatted_address;
    const lat = addressObject.geometry.location.lat();
    const lng = addressObject.geometry.location.lng();
    setAddress(address);
    // setMapCenter({ lat, lng });
    setMarkerPosition({ lat, lng });
  };

  // handle map click
  const handleMapClick = (e) => {
    // get full address
    const geocoder = new window.google.maps.Geocoder();
    geocoder.geocode({ location: e.latLng }, (results, status) => {
      if (status === "OK") {
        if (results[0]) {
          document.getElementById("autocomplete-input").value =
            results[0].formatted_address;
          const address = results[0].formatted_address;
          setAddress(address);
        }
      }
    });

    const lat = e.latLng.lat();
    const lng = e.latLng.lng();
    setMarkerPosition({ lat, lng });
  };

  // handle marker drag
  const handleMarkerDrag = (e) => {
    const lat = e.latLng.lat();
    const lng = e.latLng.lng();

    setMarkerPosition({ lat, lng });

    // change autocomplete value
    const geocoder = new window.google.maps.Geocoder();
    geocoder.geocode({ location: { lat, lng } }, (results, status) => {
      if (status === "OK") {
        if (results[0]) {
          document.getElementById("autocomplete-input").value =
            results[0].formatted_address;

          const address = results[0].formatted_address;
          setAddress(address);
        }
      }
    });
  };

  if (!isLoaded) return <Loader />;

  return (
    <div className="map-container">
      <GoogleMap
        center={markerPosition}
        zoom={6}
        onLoad={onLoad}
        onClick={handleMapClick}
        options={{
          disableDefaultUI: true,
        }}
        // mapTypeId="satellite"
      >
        {markerPosition && (
          <Marker
            position={markerPosition}
            draggable={true}
            onDragEnd={handleMarkerDrag}
            icon={customMarkerIcon}
            animation={selectedMarker && window.google.maps.Animation.BOUNCE}
          ></Marker>
        )}
        <Autocomplete
          className="autocomplete-container"
          onLoad={(autoC) => setAutocomplete(autoC)}
          onPlaceChanged={handlePlaceSelect}
        >
          <>
            {/* <MarkerIcon /> */}
            <input
              type="text"
              placeholder={formatMessage({ id: "searchLocation" })}
              className="form-control"
              id="autocomplete-input"
              defaultValue={address}
            />
          </>
        </Autocomplete>
      </GoogleMap>
    </div>
  );
};

export default Map;
